import { useSelector, useDispatch } from "react-redux";
import { useEffect, useMemo } from "react";
import { getOwnPostAction } from "../redux/actions/postActions";
import { getJoinedCommunitiesAction } from "../redux/actions/communityActions";
import { useNavigate, useParams } from "react-router-dom";
import CommonLoading from "../components/loader/CommonLoading";
import ContentWithCards from "../components/shared/ContentWithCards";

import PostView from "../components/post/PostView";

const OwnPost = () => {
  const { postId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userData = useSelector((state) => state.auth?.userData);

  useEffect(() => {
    dispatch(getOwnPostAction(postId));
    dispatch(getJoinedCommunitiesAction());
  }, [dispatch, postId]);

  const { ownPost: post } = useSelector((state) => state.posts);

  const isAuthorized = useMemo(() => {
    // Always allow access to view posts - no restrictions
    return true;
  }, []);

  useEffect(() => {
    if (isAuthorized === false) {
      navigate("/access-denied");
    }
  }, [isAuthorized, navigate]);

  if (!post)
    return (
      <ContentWithCards>
        <div className="col-span-3 flex justify-center items-center h-screen">
          <CommonLoading />
        </div>
      </ContentWithCards>
    );

  return (
    <ContentWithCards>
      <PostView post={post} userData={userData} />
    </ContentWithCards>
  );
};

export default OwnPost;
